export const APP_VERSION = '1.0.1';

//Changelog
// 1.0.1 - 2023-10-01 - Removed use of useAllClimbs and now pass route information with Activity
